<template>
  <div class="main-index">
    <zcy-header />
    <search
      :handleSearch="handleSearch"
      :searchText="searchText"
      :onSerachChange="onSerachChange"
    />
    <div class="content">
      <zcy-menu
        :handleMenuClick="handleMenuClick"
        :openKeys="openKeys"
        :selectedKeys="selectedKeys"
        :handleOpenChange="handleOpenChange"
      />
      <zcy-list
        :list="list"
        :changePage="changePage"
        :total="total"
        :title="rTitle"
        :isLoading="isLoading"
        :current="current"
        :isSearching="isSearching"
        :reset="reset"
      />
    </div>
    <sidebar />
    <zcy-bottom></zcy-bottom>
    <zcy-copyright></zcy-copyright>
  </div>
</template>
<script>
import request from '@/utils/request';
import moment from 'moment';
import Search from './search.vue';
import ZcyMenu from './menu.vue';
import ZcyList from './list.vue';
import ZcyHeader from '@/components/header';
import AppIcon from '@/components/icon';
import Sidebar from '@/components/sidebar';
import Bottom from '@/components/bottom';
import Copyright from '@/components/copyright';
import { getQueryParams } from '@/utils/utils';

// import { getUseProfile, getHomePageApps } from '@/services';
const defaultConfig = {
  openKeys: ['a1'],
  selectedKeys: ['3001'],
  rightTitle: '公开招标公告',
  current: 1
};

export default {
  name: 'index',
  data () {
    const query = getQueryParams(location.search);
    const searchText = query.searchText;
    const isSearching = typeof searchText !== 'undefined';
    return {
      // 是否在搜索
      isSearching,
      // 加载中
      isLoading: true,
      // 搜索文字
      searchText: searchText || '',
      // 公告列表
      list: [],
      // 公告总数
      total: 0,
      // 当前页码
      current: 1,
      // 打开
      openKeys: isSearching ? [] : defaultConfig.openKeys,
      // 选中
      selectedKeys: isSearching ? [] : defaultConfig.selectedKeys,
      // 选中的标题
      rightTitle: isSearching ? '搜索结果' : defaultConfig.rightTitle
    };
  },
  created () {
    this.queryList();
  },
  components: {
    'zcy-header': ZcyHeader,
    'search': Search,
    'zcy-menu': ZcyMenu,
    'zcy-list': ZcyList,
    'app-icon': AppIcon,
    'sidebar': Sidebar,
    'zcy-copyright': Copyright,
    'zcy-bottom': Bottom
  },
  computed: {
    rTitle () {
      return this.isSearching ? '搜索结果' : this.rightTitle;
    }
  },
  methods: {
    handleSearch (val) {
      this.isSearching = true;
      this.selectedKeys = [];
      this.openKeys = [];
      this.current = 1;
      this.total = 0;
      this.isLoading = true;
      this.searchText = val;
      this.queryList();
    },
    onSerachChange (val) {
      this.searchText = val;
    },
    queryList () {
      const url = this.isSearching ? '/new/globalFullTextSearch' : '/new/noticeSearch';
      const data = {
        pageSize: 15,
        pageNo: this.current
      };

      if (!this.isSearching) {
        const selected = this.selectedKeys[0];
        // 区划是6位33开头
        if (/^33\d{4}$/.test(selected)) {
          data.district = selected;
        } else {
          data.sourceAnnouncementType = this.selectedKeys[0];
        }
      } else {
        data.keyword = this.searchText;
      }

      request(url, {
        params: data
      }).then(res => {
        if (res) {
          const { count, pageNo, articles = [] } = res;
          articles && articles.forEach(item => {
            item.date = moment(+item.pubDate).format('YYYY-MM-DD');
            item.districtType = `${item.districtName}-${item.typeName}`;
          });
          this.total = count || 0;
          this.pageNo = pageNo;
          this.list = articles;
        } else {
          this.$message.error('网络繁忙，请稍后重试');
        }
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      });
    },
    changePage (pageNo) {
      this.current = pageNo;
      this.isLoading = true;
      this.queryList();
    },
    handleMenuClick (key, title) {
      this.selectedKeys = [key];
      this.current = 1;
      this.isSearching = false;
      this.total = 0;
      this.isLoading = true;
      this.rightTitle = title;

      this.queryList();
    },
    handleOpenChange (openKeys) {
      this.openKeys = openKeys;
    },
    reset () {
      this.isSearching = false;
      this.openKeys = defaultConfig.openKeys;
      this.selectedKeys = defaultConfig.selectedKeys;
      this.rightTitle = defaultConfig.rightTitle;
      this.current = 1;
      this.searchText = '';
      this.queryList();
    }
  }
};
</script>
<style lang="less">
@import '../../assets/css/common.less';
html,body {
  margin: 0;
  font-family: @family-nomal;
  font-size: @font-size-s;
  color: @font-color-main;
  background: @site-bg-color;
  -webkit-font-smoothing: antialiased;
}
a {
  text-decoration: none;
}
.main-index {
  .header__wrapper {
    background: #fff;
    .header {
      padding: 10px 0;
      width: 1200px;
      height: 64px;
      padding: 11px 0;
      margin: 0 auto;
      #logo {
        float: left;
        height: 42px;
        a {
          .anticon {
            float: left;
            font-size: 42px;
            margin-right: 12px;
          }
          b {
            float: left;
            color: #384967;
            font-size: 24px;
            font-weight: normal;
            line-height: 42px;
          }
        }
      }
      .top-nav {
        float: right;
        .app-store, .feedback-box {
          float: left;
          line-height: 42px;
          font-size: 14px;
          &:hover {
            color: #00BBEF;
          }
        }
        .feedback-box {
          margin-left: 20px;
          a:hover {
            color: #00BBEF;
          }
        }
      }
    }
  }
  .content {
    position: relative;
    width: 1200px;
    margin: 30px auto;
    border-radius: 2px;
    .zcy-menu {
      position: absolute;
      width: 300px;
      top: 0;
      left: 0;
      .ant-menu-inline {
        border: none;
      }
    }
    .zcy-list {
      height: 927px;
      padding: 0 40px 40px 39px;
      margin: 0 20px 0 300px;
      border-left: 1px solid #e9e9e9;
      background: #fff;
      .hd {
        height: 60px;
        line-height: 60px;
        font-size: 16px;
        border-bottom: 1px solid #e9e9e9;
        color: #404040;
        font-weight: bold;
        .reset-btn {
          float: right;
          margin-top: 14px;
        }
      }
      .bd {
        padding-top: 16px;
        .list-container {
          margin-bottom: 10px;
        }
        .list-item {
          padding: 9px 0;
          line-height: 32px;
          font-size: 14px;
          .item-link {
            display: block;
            position: relative;
            padding: 0 100px 0 140px;
            &:hover {
              .mid {
                .no-wrap;
                color: #00BBEF;
                em {
                  color:#00BBEF;
                }
              }
            }
          }
          .left {
            position: absolute;
            width: 130px;
            padding-left: 5px;
            top: 0;
            left: 0;
            color: #FF8322;
            // padding: 0 10px;

            &:before {
              content: '[';
              color: #FF8322;
              position: absolute;
              top: 0;
              left: 0;
            }
            .left-title {
              position: relative;
              vertical-align: top;
              padding-right: 5px;
              display: inline-block;
              max-width: 122px;
              .no-wrap;
              &:after {
              content: ']';
              display: block;
              color: #FF8322;
              position: absolute;
              right: 0;
              top: 0;
            }
            }
          }
          .mid {
            .no-wrap;
            color: #404040;
            em {
              color:#197AFF;
            }
          }
          .right {
            position: absolute;
            width: 100px;
            top: 0;
            right: 0;
            text-align: right;
            font-size: 12px;
            color: #9B9B9B;
          }
        }
        .pagination-wrap {
          padding: 10px 0;
          text-align: right;
        }
        .list-empty {
          height: 343px;
          background: url(https://sitecdn.zcycdn.com/zcy-front-other-upload/9dd7d781e5f78f60c09737b7adb01383.png?x-oss-process=image/quality,Q_75/format,jpg) no-repeat center center #fff;
          background-size: 116px 121px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue